import { getAuthToken } from './authApi';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5215';

const request = async (path, options = {}) => {
  const token = getAuthToken();
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });

  if (!response.ok) {
    let details = null;
    try {
      details = await response.clone().json();
    } catch {
      details = await response.clone().text();
    }
    const err = new Error(`HTTP ${response.status}`);
    err.status = response.status;
    err.details = details;
    throw err;
  }

  if (response.status === 204) return null;
  return response.json();
};

export const getActiveWatches = () =>
  request('/api/event-watcher/active');

export const getEventHistory = (monitoredEventId) =>
  request(`/api/event-watcher/events/${monitoredEventId}`);

export const getEventAlerts = (monitoredEventId) =>
  request(`/api/event-watcher/events/${monitoredEventId}/alerts`);

export const acknowledgeAlert = (alertId) =>
  request(`/api/event-watcher/alerts/${alertId}/ack`, { method: 'POST' });

export const getWatcherTenants = () =>
  request('/api/event-watcher/tenants');

export const upsertWatcherTenant = (config) =>
  request('/api/event-watcher/tenants', {
    method: 'PUT',
    body: JSON.stringify(config),
  });
